(() => {
  if (window.tshProductCarouselLoaded) return;
  window.tshProductCarouselLoaded = true;
  const instances = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-tsh-carousel]').forEach(section => {
      if (instances.has(section)) return;
      const track = section.querySelector('[data-carousel-track]');
      const controls = section.querySelector('[data-carousel-controls]');
      const previous = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      const thumb = section.querySelector('[data-carousel-thumb]');
      if (!track || !controls || !previous || !next || !thumb) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frame;
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.max(0, Math.min(max, track.scrollLeft));
        controls.hidden = max < 2;
        previous.disabled = position < 2;
        next.disabled = position >= max - 2;
        const visible = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
        thumb.style.width = `${visible * 100}%`;
        thumb.style.left = `${max ? position / max * (1 - visible) * 100 : 0}%`;
      };
      const scrollTo = left => track.scrollTo({
        left,
        behavior: reduce.matches ? 'instant' : 'smooth'
      });
      const advance = direction => {
        const card = track.querySelector('[data-carousel-item], .tsh-product');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap + 1) / step));
        scrollTo(track.scrollLeft + direction * step * visibleCards);
      };
      previous.addEventListener('click', () => advance(-1), options);
      next.addEventListener('click', () => advance(1), options);
      track.addEventListener('keydown', event => {
        // Preserve native video controls and other interactive children's keys.
        if (event.target !== track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') scrollTo(0);
        else if (event.key === 'End') scrollTo(track.scrollWidth);
        else advance(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { ...options, passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      section.classList.add('tsh-carousel-ready');
      update();
      instances.set(section, () => {
        abort.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
        instances.delete(section);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, section) => {
      if (event.target.contains(section)) destroy();
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-carousel-item], .tsh-product');
    const track = card?.closest('[data-carousel-track]');
    if (card && track) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'instant' });
  });
})();
